import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import React from 'react';
import Select, { components } from "react-select";
import { FontColors } from "theme/fontConfig";


const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: FontColors.Slate3F4254,
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const secondaryStyle = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected
      ? "#E4E6EF"
      : isFocused
      ? "#EBEDF3" 
      : "transparent",
    color: FontColors.Slate3F4254,
    cursor: "pointer",
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const formatSingleValue = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};



const Selection = ({ 
  name, 
  mandatory, 
  placeholder, 
  options, 
  isLoading, 
  onChange, 
  value, 
  isClearable, 
  style, 
  isDisabled, 
  isMulti = false,
  onInputChange,
  onMenuScrollToBottom,
  customFormatOptionLabel,
}) => {
  return (
    <Select
      {...{
        name: name,
        mandatory: mandatory,
        checkValidation: false,
      }}
      placeholder={placeholder}
      classNamePrefix="react-select"
      styles={style === "secondary" ? secondaryStyle : {}}
      formatOptionLabel={customFormatOptionLabel || formatOptionLabel}
      components={{ 
        DropdownIndicator,
        SingleValue: ({ children, ...props }) => (
          <components.SingleValue {...props}>
            {formatSingleValue(props.data)}
          </components.SingleValue>
        )
      }}
      options={options}
      isLoading={isLoading}
      onChange={onChange}
      isClearable={isClearable}
      value={value}
      isDisabled={isDisabled || false}
      isMulti={isMulti}
      onInputChange={onInputChange}
      onMenuScrollToBottom={onMenuScrollToBottom}
    />
  )
}

export default Selection